import find from 'lodash/find'
import React from 'react'
import { AccountContainer } from '../../AccountContainer'
import { Tab, Tabs } from 'react-bootstrap'
import { useOrderListContext } from './Context'
import { useSearchParams } from 'react-router-dom'
import { TabName } from './TabName'
import { OrderTable } from './OrderTable'
import { PageTitle } from '../../../../components/PageTitle'

export const Layout = () => {
  const { getTabTitle } = useOrderListContext()

  const [searchParams, setSearchParams] = useSearchParams()
  let activeTab = searchParams.get('activeTab')
  activeTab = find(TabName, (e) => e === activeTab) || 'all'

  return (
    <AccountContainer>
      <PageTitle
        title="Order History"
        description="View your order history, track shipments, and manage your purchases."
      />
      <Tabs
        variant="underline"
        defaultActiveKey={activeTab}
        onSelect={(e) => setSearchParams({ activeTab: e })}
        transition={false}
        id="order-tabs"
      >
        <Tab eventKey={TabName.all} title="All">
          <OrderTable tabName={TabName.all} />
        </Tab>
        <Tab eventKey={TabName.inCart} title={getTabTitle(TabName.inCart)}>
          <OrderTable tabName={TabName.inCart} />
        </Tab>
        <Tab eventKey={TabName.quotation} title={getTabTitle(TabName.quotation)}>
          <OrderTable tabName={TabName.quotation} />
        </Tab>
        <Tab eventKey={TabName.order} title={getTabTitle(TabName.order)}>
          <OrderTable tabName={TabName.order} />
        </Tab>
        {/*<Tab eventKey={TabName.paid} title={getTabTitle(TabName.paid)}>*/}
        {/*  <OrderTable tabName={TabName.paid} />*/}
        {/*</Tab>*/}
        <Tab eventKey={TabName.shipping} title={getTabTitle(TabName.shipping)}>
          <OrderTable tabName={TabName.shipping} />
        </Tab>
        <Tab eventKey={TabName.delivered} title={getTabTitle(TabName.delivered)}>
          <OrderTable tabName={TabName.delivered} />
        </Tab>
        <Tab eventKey={TabName.canceled} title={getTabTitle(TabName.canceled)}>
          <OrderTable tabName={TabName.canceled} />
        </Tab>
      </Tabs>
    </AccountContainer>
  )
}
